import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { PaddleConfigurationFooter } from './components/PaddleConfigurationFooter';
import { PaddleConfigurationForm } from './components/PaddleConfigurationForm';
import type { PaddleConfigurationFormValues } from './PaddleConfigurationFormSchema';
import { PaddleConfigurationFormSchema } from './PaddleConfigurationFormSchema';

export const ConfigurePaddleComponents: FormDrawerProps<ZodSchema<PaddleConfigurationFormValues>> = {
  zodSchema: PaddleConfigurationFormSchema,
  ContentComponent: PaddleConfigurationForm,
  Footer: PaddleConfigurationFooter,
};
